import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IBcContestProgram } from '../../../models/BcContest';

import { AppService } from '../../../services/app.service';
import { BcContestService } from '../../../services/bc-contest.service';
import { ITableColumn } from '../../../shared/table/table.component';
import { bcState } from '../shared';
import { BcContestSubmitComponent } from '../submit/bc-contest-submit.component';

@Component({
    selector: 'app-bc-contest-programs',
    templateUrl: './bc-contest-programs.component.html',
    styleUrls: ['../bc-contest.scss']
})
export class BcContestProgramsComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: BcContestService,
        private modal: NgbModal
    ) { }

    @Input() contestId: number;

    readonly columns: ITableColumn[] = [
        { property: 'Code', label: 'bcContestProgram_lblProgram', sorts: true },
        { property: 'Total', label: 'bcContestProgram_lblTotal', sorts: true, type: 'number' },
        { property: 'Submitted', label: 'bcContestProgram_lblSubmitted', sorts: true, type: 'number' },
        { property: 'Pending', label: 'bcContestProgram_lblPending', sorts: true, type: 'number' },
        { width: '1px' }
    ];

    items: IBcContestProgram[] = [];

    private allItems: IBcContestProgram[] = [];

    ngOnInit() {
        this.load();
    }

    filter(term?: string) {
        const s = term?.toLowerCase();

        if (s) {
            this.items = this.allItems.filter(t => t.Code.toLowerCase().includes(s));
        } else {
            this.items = this.allItems;
        }
    }

    submit(item?: IBcContestProgram) {
        const ref = this.modal.open(BcContestSubmitComponent, { size: 'md' });

        ref.componentInstance.contestId = this.contestId;

        if (item) {
            ref.componentInstance.program = item.Code;
        }

        ref.closed.subscribe((success: boolean) => {
            bcState.clearApplications();
            this.load();
        });
    }

    private load() {
        this.app.addLoading(this.service.getPrograms(this.contestId)).subscribe(data => {
            this.allItems = data;
            this.filter();
        });
    }
}
